export default {
    MolegameTitle: "Mole Game Settings",
    gameTitle: "Mole Game",
    topicLabel: "Topic",
    correctItems: "Correct Items",
    correctItemsPlaceholder: "Enter correct words, separated by commas (,), press Enter to add",
    errorItems: "Error Items",
    errorItemsPlaceholder: "Enter error words, separated by commas (,), press Enter to add",
    gameDuration: "Game Duration",
    moleSpeed: "Mole Stay Duration",
    speedSlow: "Long (2.5s)",
    speedMedium: "Medium (2s)",
    speedFast: "Short (1.5s)",
    speedVeryFast: "Very Short (1s)",
    second: "seconds",
    saveSettings: "Save Settings",
    startGame: "Start Game",
    pauseGame: "Pause Game",
    resumeGame: "Resume Game",
    gameOver: "Game Over",
    leftSide: "Left Side",
    rightSide: "Right Side",
    leftWins: "Left Side Wins!",
    rightWins: "Right Side Wins!",
    tie: "It's a Tie!",
    playAgain: "Play Again",
    wordExists: "Word already exists, no need to add again",
    maxVocabulary: "Maximum number of correct words reached, please remove some before adding more",
    maxErrorVocabulary: "Maximum number of error words reached, please remove some before adding more",
    topic: "Topic",
    inputTopic: "Please enter topic",
    backgroundSetting: "Background Setting",
    ocean: "Ocean",
    desert: "Desert",
    forest: "Forest",
    
    // Game over screen strings
    win: "Victory",
    items: "",
    wrongItems: "Correct Items",
    maxCombo: "Max Combo",
    showAnswers: "A",
    gamePaused: "Game Paused",
    referenceAnswers: "Reference Answers",
    clearData: "Clear Data",
    sendSuccess: "Game data sent successfully!",
    sendCooldown: "Already sent, please wait 1 minute before operating again",
    configLoadSuccess: "Game configuration loaded successfully",
    configLoadFailed: "Load failed (using example configuration)",
}